import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: 'What makes The Gloss & Chrome Lab different from other nail salons?',
  answer: 'We specialize in futuristic nail artistry — from liquid chrome finishes to holographic designs. Our lab-like environment, proprietary techniques, and curated collection of over 500 premium shades set us apart as a destination for those who see nails as wearable art.'
}, {
  question: 'How long does a Chrome Couture appointment take?',
  answer: 'A Chrome Couture session typically takes 60–90 minutes depending on the complexity of your chosen design. We never rush our artistry — every detail is meticulously crafted to ensure a flawless, mirror-like finish.'
}, {
  question: 'Do I need to book an appointment in advance?',
  answer: 'Yes, we highly recommend booking in advance as our appointment slots fill up quickly. You can reserve your session through our website or by contacting us directly. Walk-ins are welcome based on availability.'
}, {
  question: 'What products do you use?',
  answer: 'We use a curated selection of premium, cruelty-free products including imported Japanese gels, proprietary holographic dusts, and luxury hand care formulations. All products are chosen for their superior pigment, longevity, and safety.'
}, {
  question: 'How long do chrome and holographic nails last?',
  answer: 'With proper care, our chrome and holographic finishes last 3–4 weeks without chipping or dulling. We provide aftercare instructions and recommend a maintenance visit every 2–3 weeks to keep your nails looking pristine.'
}, {
  question: 'Do you offer gift cards or group bookings?',
  answer: 'Absolutely! We offer digital and physical gift cards in any denomination. For group bookings — bridal parties, birthdays, or corporate events — please contact us directly so we can create a bespoke experience for your group.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-24 px-6 md:px-12" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-39">
          <h2 className="font-syncopate font-bold text-4xl md:text-5xl text-black tracking-widest mb-4" data-id="element-40">
            FAQ
          </h2>
          <p className="text-black/60 font-light text-lg" data-id="element-41">
            Everything you need to know before your visit
          </p>
          <div className="h-px w-24 bg-black/20 mx-auto mt-6" data-id="element-42" />
        </motion.div>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.08
        }} data-id="element-44">
              <div className="glass-panel rounded-2xl overflow-hidden transition-all duration-300" data-id="element-45">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-6 md:p-8 text-left gap-4" data-id="element-46">
                  <span className="font-medium text-black text-base md:text-lg leading-snug" data-id="element-47">
                    {faq.question}
                  </span>
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-black/5 flex items-center justify-center" data-id="element-48">
                    {openIndex === index ? <MinusIcon size={16} className="text-black" data-id="element-49" /> : <PlusIcon size={16} className="text-black" data-id="element-50" />}
                  </span>
                </button>
                <AnimatePresence data-id="element-51">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-52">
                      <div className="px-6 md:px-8 pb-6 md:pb-8 pt-0" data-id="element-53">
                        <p className="text-black/70 font-light leading-relaxed" data-id="element-54">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}